//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { cachedSetEconomicsCustomKpiDataSite } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

export const EconomicsCustomKpiSiteResolver = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const pathSegment = location.pathname.split('/')[1];
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const user = useSelector((state: any) => state.user);

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {
    if (
      !user ||
      user.logOut === true ||
      user.isLoggingOut === true ||
      !user.tokenContent
    ) {
      return;
    }

    if (!pathSegment?.includes('site') && !pathSegment?.includes('household')) {
      return;
    }

    const SITE_ID = params?.id || metadata?.entities?.site?.[0]?.siteId;

    if (!SITE_ID) {
      return;
    }

    // Token auto-injected by httpService interceptor
    dispatch(
      cachedSetEconomicsCustomKpiDataSite({
        SITE_ID,
        selectedDate,
        selectedTimeSet,
      }) as any
    );
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    init();
  }, [selectedDate, metadata?.entities, params?.id, pathSegment]);
  return <></>;
};
